/**
 * 加载JavaScript链接
 * @param {String} url JavaScript链接
 * @param {Function} hasCallback 回调
 */
export default function remoteLoad(url, hasCallback) {
  let jsUrl = url;
  const scriptElement = document.createElement('script');
  scriptElement.attributes.type = 'text/javascript';
  scriptElement.attributes.charset = 'UTF-8';
  document.body.appendChild(scriptElement);
  const promise = new Promise((resolve, reject) => {
    scriptElement.addEventListener('load', (e) => {
      // 移除script标签
      document.body.removeChild(scriptElement);
      if (!hasCallback) {
        resolve(e);
      }
    }, false);
    scriptElement.addEventListener('error', (e) => {
      // 移除script标签
      document.body.removeChild(scriptElement);
      reject(e);
    }, false);
    if (hasCallback) {
      // eslint-disable-next-line
      window.____callback____ = () => {
        resolve();
        // eslint-disable-next-line
        window.____callback____ = null;
      };
    }
  });
  if (hasCallback) {
    jsUrl += '&callback=____callback____';
  }
  scriptElement.src = jsUrl;
  return promise;
}
